import styled from "styled-components";
import { motion } from "framer-motion";

export const Container = styled(motion.div)`
  width: 100%;
  padding: 0em 10%;
  z-index: 20;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 0em 5%;
  }
`;
export const Heading = styled(motion.div)`
  z-index: 20;
  width: 27.3125rem;
  margin-top: 5.2em;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 2.56em;
    justify-content: center;
    width: 100%;
    text-align: center;
  }
`;
export const H1 = styled.div`
  color: #351182;
  font-family: Poppins;
  font-size: 2.875rem;
  font-weight: 800;
  font-style: normal;
  line-height: 151.724%; /* 4.36206rem */
  width: 27.3125rem;
  display: flex;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    justify-content: center;
    text-align: center;
    color: #351182;
    font-size: 1.8125rem;
    width: 17.5625rem;
    align-self: center;
  }
`;
export const Description = styled.div`
  margin-top: 1.8em;
  color: #000;
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 1.56em;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-bottom: 1.2em;
    margin-top: 0.8em;
    color: #000;
    text-align: center;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
export const HalfCard = styled.div`
  margin-top: 5.2em;
  display: flex;
  flex-direction: column;
  width: 32.3125rem;
  flex-shrink: 0;
  border-radius: 1.25em;
  background: #fff;
  box-shadow: 0px 0px 19px 0px rgba(139, 139, 139, 0.25);
  padding: 3em;
  text-align: center;
  align-items: center;
  h1 {
    color: #434343;
    font-family: Poppins;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
      font-size: 1.25rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding: 2em 1.4em;
    margin-top: 23.56em;
    width: 100%;
  }
`;
export const CardH = styled.div`
  width: 70%;
  border-bottom: 0.0625rem solid #d9d9d9;
  margin-bottom: 1.3em;
  p {
    margin-bottom: 1.3em;
    color: #9f9f9f;
    font-family: Poppins;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    span {
      border-radius: 0.625rem;
      background: #dfd0ff;
      color: #434343;
      font-family: Poppins;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding: 0.2em 1em;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
  }
`;
export const HalfCardD = styled.div`
  color: #474747;
  text-align: center;
  font-family: Poppins;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 1.5em 0;
`;
export const Explore = styled.a`
  color: #303030;
  text-align: center;
  font-family: Poppins;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  margin-top: 2em;
`;
export const Bottom = styled.div`
  margin: 4.2em 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
  h1 {
    color: #434343;
    text-align: center;
    font-family: Poppins;
    font-size: 1.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 1.5em;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    flex-direction: column;
    align-items: center;
    h1 {
      font-size: 1.5rem;
      margin-bottom: 1em;
      text-align: center;
      font-family: Poppins;
      font-size: 1.25rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      width: 13.125rem;
    }
  }
`;
export const ElipseOverlay = styled(motion.div)`
  position: absolute;
  top: 2.5em;
  right: 0;
  z-index: -1;
  img {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    top: 31.12em;
    right: -40%;
    img {
      width: 80%;
    }
  }
`;
export const IconOverlay = styled(motion.div)`
  position: absolute;
  top: 13em;
  right: -5.2em;
  z-index: -1;
  width: 54.98681rem;
  height: 53.25rem;
  img {
    width: 100%;
    flex-shrink: 0;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    top: 23.9em;
    /* left: 50%; */
    /* transform: translateX(-50%); */
    width: 21.55588rem;
    height: 20.875rem;
    img {
      width: 100%;
    }
  }
`;
export const RectangleOverlay = styled.div`
  position: absolute;
  top: 55.1em;
  left: 0;
  z-index: -2;
  width: 100%;
  img {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 35.5625rem;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;
export const WaveOverlay = styled.div`
  position: absolute;
  top: 88.5em;
  left: 0;
  z-index: -1;
  width: 100%;
  img {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 133rem;
    width: 45.75rem;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
